import ValoresRepository from '@/services/ValoresRepository'

export default {
  namespaced: true,
  state: {
    temporada: { nombre: 'Elija Temporada', idTemporada: null, temporadaHabilitada: true },
    listaTemporada: [],
    listaTemporadaAgricultor: [],
    temporadaActual: null,
  },
  getters: {
    isTemporadaSet(state) {
      return state.temporada?.idTemporada !== null
    },

    getTemporadaAgricultor: (state) => (idTemporada) => {
      return state.listaTemporadaAgricultor.find(temporada => temporada.idTemporada === idTemporada)
    },

    filteredListaTemporadaAgricultor(state) {
      return state.listaTemporadaAgricultor.filter(temporada => temporada.idTemporada !== state.temporada.idTemporada)
    },

    getTemporadasPendientes(state){
      return state.listaTemporada.filter(temporada=>temporada.estado === 1)
    }
  },
  mutations: {
    setTemporada(state, temporada) {
      state.temporada = temporada
      localStorage.setItem('selectedTemporada', JSON.stringify(state.temporada))
    },

    setListaTemporada(state, listaTemporada) {
      state.listaTemporada = listaTemporada
    },

    setListaTemporadaAgricultor(state, listaTemporadaAgricultor) {
      state.listaTemporadaAgricultor = listaTemporadaAgricultor
      if (state.temporadaActual && state.temporadaActual.idTemporada) {
        let actual = state.listaTemporadaAgricultor.find((temp) => temp.idTemporada === state.temporadaActual.idTemporada)
        if (actual && actual.idTemporada) {
          state.temporadaActual = actual
        }
      }
      state.temporada = state.listaTemporadaAgricultor[state.listaTemporadaAgricultor.length - 1]
    },

    setTemporadaActual(state, temporadaActual) {
      state.temporadaActual = temporadaActual
    },

    clearTemporadaAgricultor(state) {
      state.temporada = { nombre: 'Elija Temporada', idTemporada: null, temporadaHabilitada: true }
      state.listaTemporadaAgricultor = []
      state.temporadaActual = null
      localStorage.removeItem('selectedTemporada')
    },

    restoreTemporada(state) {
      let selectedTemporada = localStorage.getItem('selectedTemporada')

      if (selectedTemporada && selectedTemporada != 'undefined') {
        state.temporada = JSON.parse(selectedTemporada)
      } else if (state.temporadaActual) {
        state.temporada = state.listaTemporadaAgricultor.find(temporada => temporada.idTemporada === state.temporadaActual.idTemporada) || state.listaTemporadaAgricultor[state.listaTemporadaAgricultor.length - 1]
      }
    },
  },
  actions: {
    async setTemporada({ rootGetters, commit, dispatch }, temporada) {
      commit('setTemporada', temporada)

      await dispatch('session/clear', { isSetTemporada: true }, { root: true })
      if (rootGetters['agricultor/isAgricultorSet']) {
        await dispatch('fichas/fetchListaFichaAgricola', null, { root: true })
      }
    },

    async fetchListaTemporada({ state, commit }) {
      if (state.listaTemporada && state.listaTemporada.length > 0) {
        return
      }

      let listaTemporada = await ValoresRepository.listaTemporada()
      commit('setListaTemporada', listaTemporada)
    },

    async fetchListaTemporadaAgricultor({ state, commit, rootState }) {
      if (state.listaTemporadaAgricultor && state.listaTemporadaAgricultor.length > 0) {
        return
      }

      let idEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let idGrupoExplotacion = rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion

      if (idEstablecimiento !== 0 && idGrupoExplotacion !== 0) {
        let listaTemporadaAgricultor = await ValoresRepository.listaTemporadaAgricultor(idEstablecimiento, idGrupoExplotacion)
        commit('setListaTemporadaAgricultor', listaTemporadaAgricultor)
      }
    },

    async fetchTemporadaActual({ state, getters, commit }) {
      if (state.temporadaActual) {
        return
      }

      let temporadaActual = await ValoresRepository.temporadaActual()
      commit('setTemporadaActual', temporadaActual)

      // if (!getters.isTemporadaSet) {
      //   let temporada = getters.getTemporadaAgricultor(temporadaActual.idTemporada) || state.temporadaActual
      //   if(!temporada.hasOwnProperty('temporadaHabilitada')){
      //     // api temporadaActual doesnt return temporadaHabilitada key so it appears in app as of temporada is finished
      //     let date = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString()
      //     temporada.temporadaHabilitada = temporada.periodoFin > date
      //   }
      //   commit('setTemporada', temporada)
      // }
    },

    clearTemporadaAgricultor({ commit }) {
      commit('clearTemporadaAgricultor')
    },

    async restoreTemporada({ commit, dispatch }) {
      await dispatch('fetchListaTemporadaAgricultor')
      commit('restoreTemporada')
      await dispatch('fetchTemporadaActual')
    },
  }
}
